import React from "react";
import Navbar from "../components/common/navbar";
import MyOrders from "../components/account/myOrders";
import Footer from "../components/common/footer";
import MobileSidebarLink from "../components/account/mobileSidebarLink";

const MyOrderPage = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-16 flex">
        <div className="hidden md:block">
          <MobileSidebarLink />
        </div>
        <MyOrders />
      </div>
      <Footer />
    </div>
  );
};

export default MyOrderPage;
